import { Vector2, Vector3, Line3 } from 'three';
import { Line3X } from './Line3Extensions';
export class Line2
{
  start:Vector2;
  end:Vector2;

  constructor( start:Vector2, end:Vector2 )
  {
    this.start = start;
    this.end = end;
  }

  private _toVector3( point:Vector2 )
  {
    return new Vector3( point.x, point.y, 0 ); 
  }

  private get _line3()
  {
    return new Line3( this._toVector3( this.start ), this._toVector3( this.end ) );
  }

  distanceToPoint( point:Vector2, clamp:boolean = true )
  {
    let point3 = this._toVector3( point );
    let line3  = this._line3;  

    return Line3X.distanceToPoint( line3, point3, clamp );
  }

  distanceToLine2( line2:Line2 )
  {
    return Line3X.distanceToLine( this._line3, line2._line3 );
  }
  
  get  A(){  return this.end.y - this.start.y; }
  get  B(){  return this.start.x - this.end.x; }
  get  C(){  return this.A * this.start.x + this.B * this.start.y; }

  infiniteIntersectionOf( line2:Line2 ):Vector2
  {
    var A1 = this.A;
    var B1 = this.B;
    var A2 = line2.A;
    var B2 = line2.B;

    var determinant = A1 * B2 - A2 * B1;

    if ( Math.abs( determinant ) < 0.0000001 )
    { 
      return null;
    }

    var inverseDeterminant = 1 / determinant;

    var C1 = A1 * this.start.x + B1 * this.start.y;
    var C2 = A2 * line2.start.x + B2 * line2.start.y;

    var x = ( B2 * C1 - B1 * C2 ) * inverseDeterminant;
    var y = ( A1 * C2 - A2 * C1 ) * inverseDeterminant;

    return new Vector2( x, y );
  }

  intersectionOf( other:Line2 ):Vector2
  {
    var possibleIntersection = this.infiniteIntersectionOf( other );
    
    if ( possibleIntersection == null )
    {
      return null;
    }

    var point = possibleIntersection;

    if ( ! this.isValueInRange( point.x, this.start.x, this.end.x ) ) 
    {
      return null;
    }
    
    if ( ! this.isValueInRange( point.y, this.start.y, this.end.y ) )
    {
      return null;
    }

    if ( ! this.isValueInRange( point.x, other.start.x, other.end.x ) ) 
    {
      return null;
    }
    
    if ( ! this.isValueInRange( point.y, other.start.y, other.end.y ) )
    {
      return null;
    }

    return point;
  }

  intersectsWith( other:Line2 ):boolean
  {
    return this.intersectionOf( other ) != null;
  }

  isValueInRange( value:number, start:number, end:number ):boolean
  {
    var min = Math.min( start, end );
    var max = Math.max( start, end );

    return min <= value && value <= max;    
  } 
}